export default __webpack_public_path__ + "static/anheuser-busch-ce3d54a2ade118ca2b3d4643da6b0223.svg";